import { client } from './client';

export const autoReferralApi = {
  getSettings: () => client.get('get_auto_referral_settings'),
  saveSettings: (data) => client.post('save_auto_referral_settings', data),
  saveRule: (data) => client.post('save_auto_referral_rule', data),
  toggleRule: (data) => client.post('toggle_auto_referral_rule', data),
};
